import React from 'react';

/**
 * SkeletonCard - Composant skeleton pour les cartes produits avec daisyUI
 * @param {number} count - Nombre de cartes skeleton à afficher
 */
const SkeletonCard = ({ count = 6 }) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="card bg-base-100 shadow-lg animate-pulse">
                    {/* Image skeleton */}
                    <div className="h-48 bg-base-300 rounded-t-2xl"></div>
                    
                    <div className="card-body p-6">
                        {/* Header skeleton */}
                        <div className="flex justify-between items-start mb-4">
                            <div className="space-y-2 flex-1">
                                <div className="h-4 bg-base-300 rounded w-3/4"></div>
                                <div className="h-4 bg-base-300 rounded w-1/2"></div>
                            </div>
                            <div className="w-6 h-6 bg-base-300 rounded-full ml-4"></div>
                        </div>
                        
                        {/* Price and button skeleton */}
                        <div className="flex justify-between items-center mt-4">
                            <div className="space-y-1">
                                <div className="h-6 bg-base-300 rounded w-20"></div>
                                <div className="h-3 bg-base-300 rounded w-16"></div>
                            </div>
                            <div className="h-8 bg-base-300 rounded w-32"></div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default SkeletonCard;